function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKiitLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 362.759,
    height: 275.665,
    viewBox: "0 0 387.441 294.421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#17d059",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.5 194.5 10 26 47.5-16-12.5-34zM49.905 261.298l18.307 19.938 39.643-35.484L83.18 218.86zM108.582 307.092l23.03 10.496 25.26-49.417-31.531-13.469zM181.454 326.403l25.558.268 4.474-55.929-33.926-.02zM258.806 318.817l22.93-10.75-15.426-52.439-31.088 14.34zM322.525 279.589l17.395-20.195-31.443-41.208-24.854 26.354zM366.773 219.338l9.616-25.018-44.545-24.537-13.768 34.604zM333.126 155.585l49.674-5.833v-14.673h-49.144zM5.359 149.502l49.674 5.833V134.83H5.359z",
    style: {
      fill: "#17d059",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "translate(-.359 -37.25)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M276 85A142 142 0 1 1-8 85",
    transform: "matrix(.97573 0 0 .97573 61.447 14.813)",
    style: {
      fill: "none",
      stroke: "#17d059",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 85A142 142 0 1 1-8 85",
    transform: "matrix(.7905 0 0 .7905 88.715 30.807)",
    style: {
      fill: "none",
      stroke: "#17d059",
      strokeWidth: 12.65015602,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 85A142 142 0 1 1-8 85",
    transform: "matrix(.63464 0 0 .63464 109.718 44.806)",
    style: {
      fill: "none",
      stroke: "#17d059",
      strokeWidth: 15.75706863,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m141.459 42.25-18.976 34.14V42.478h-31.5v100.29h31.5V111.84l15.18 30.474h35.802L149.808 91.94l28.085-49.69h-36.434zm4.174 8.187h20.495l-24.29 42.527 20.494 41.844H142.85l-20.747-42.072 23.53-42.299zm-46.206.085h16.003v84.656H99.427V50.522z",
    style: {
      fill: "#17d059",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "translate(-.359 -37.25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.5 30a16.75 16.75 0 1 1-33.5 0 16.75 16.75 0 1 1 33.5 0z",
    transform: "translate(-5.609 -7.5)",
    style: {
      fill: "#17d059",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.75 78.362v63.888H207V78.362h-31.25zm8.313 7.546h15.625v49.237h-15.625V85.908zM247.496 42.968V73.3h18.615l-.367 67.388h30.244V73.3h17.143V42.967zm8.923 7.548h50.256V65.18h-17.75v68.296h-15.131V65.18l-17.375-.222z",
    style: {
      fill: "#17d059",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "translate(-.359 -37.25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.5 30a16.75 16.75 0 1 1-33.5 0 16.75 16.75 0 1 1 33.5 0z",
    transform: "translate(30.391 -7.5)",
    style: {
      fill: "#17d059",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.75 78.362v63.888H243V78.362h-31.25zm8.313 7.546h15.625v49.237h-15.625V85.908z",
    style: {
      fill: "#17d059",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "translate(-.359 -37.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiitLogo);
export default __webpack_public_path__ + "static/media/kiit-logo.c841ebb3c6f27397b6c5f3ae63a268e2.svg";
export { ForwardRef as ReactComponent };